import { createContext } from "react";

const UserPointContext = createContext();

export default UserPointContext;
